import React from 'react';
import { KYCFieldRow } from './KYCFieldRow';
import { KYCField } from './PersonalInfoTab';
interface DocumentsTabProps {
  fields: KYCField[];
  onFieldChange: (id: string, updates: Partial<KYCField>) => void;
  onSelectAll: (selected: boolean) => void;
}
// Define field metadata - only Data Type for documents
const fieldMetadata: Record<string, {
  fieldType: KYCField['fieldType'];
  explanation?: string;
}> = {
  utility_bill: {
    fieldType: 'file',
    explanation: 'File upload (e.g., .pdf, .jpg)'
  },
  shop_banner: {
    fieldType: 'file',
    explanation: 'File upload (e.g., .jpg, .png)'
  },
  bank_statement: {
    fieldType: 'file',
    explanation: 'File upload (e.g., .pdf)'
  },
  tax_registration: {
    fieldType: 'file',
    explanation: 'File upload (e.g., .pdf)'
  },
  cnic_upload: {
    fieldType: 'file',
    explanation: 'File upload (e.g., .jpg, .png)'
  },
  live_photograph: {
    fieldType: 'file',
    explanation: 'File upload (e.g., .jpg, .png)'
  },
  risk_profiling: {
    fieldType: 'file',
    explanation: 'File upload (e.g., .pdf, .docx)'
  }
};
export function DocumentsTab({
  fields,
  onFieldChange,
  onSelectAll
}: DocumentsTabProps) {
  const allSelected = fields.length > 0 && fields.every(f => f.selected);
  return <div className="space-y-6 py-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-372">
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-373">
        <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex items-center justify-between" data-id="element-374">
          <div className="flex items-center" data-id="element-375">
            <input type="checkbox" checked={allSelected} onChange={e => onSelectAll(e.target.checked)} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer" data-id="element-376" />
            <span className="ml-4 text-sm font-semibold text-gray-700" data-id="element-377">
              Documents and Evidence
            </span>
          </div>
          <div className="flex space-x-12 pr-6" data-id="element-378">
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider w-24 text-center" data-id="element-379">
              Configuration
            </span>
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-380">
          {fields.map(field => {
          const metadata = fieldMetadata[field.id] || {
            fieldType: 'file',
            explanation: 'File upload (e.g., .pdf, .jpg)'
          };
          return <KYCFieldRow key={field.id} label={field.label} isSelected={field.selected} isMandatory={field.mandatory} isOptional={field.optional} fieldType={metadata.fieldType} explanation={metadata.explanation} onToggleSelect={checked => onFieldChange(field.id, {
            selected: checked
          })} onToggleMandatory={checked => onFieldChange(field.id, {
            mandatory: checked,
            optional: checked ? false : field.optional
          })} onToggleOptional={checked => onFieldChange(field.id, {
            optional: checked,
            mandatory: checked ? false : field.mandatory
          })} data-id="element-381" />;
        })}
        </div>
      </div>
    </div>;
}